// API Configuration for different environments
const getApiBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    // Production API URL
    return process.env.REACT_APP_API_URL || 'https://crafticore-production.up.railway.app';
  } else {
    // Development API URL
    return 'http://localhost:5000';
  }
};

export const API_BASE_URL = getApiBaseUrl();

// API Endpoints
export const API_ENDPOINTS = {
  BASE: `${API_BASE_URL}/api`,
  UPLOAD_IMAGE: `${API_BASE_URL}/api/admin/upload-image`,
  UPLOAD_STL: `${API_BASE_URL}/api/admin/upload-stl`,
  UPLOAD_PORTFOLIO: `${API_BASE_URL}/api/admin/upload-portfolio`,
  CONTACT: `${API_BASE_URL}/api/contact`,
  FILES: `${API_BASE_URL}/api/admin/files`,
  PORTFOLIO: `${API_BASE_URL}/api/admin/portfolio`,
  DELETE_FILE: (type: string, filename: string) => 
    `${API_BASE_URL}/api/admin/file/${type}/${filename}`,
};

// File URL helpers
export const getFileUrl = (path: string) => {
  if (process.env.NODE_ENV === 'production') {
    // In production, files should be served from CDN or cloud storage
    return `${process.env.REACT_APP_CDN_URL || API_BASE_URL}${path}`;
  } else {
    // In development, files are served by the React dev server from public folder
    return path.startsWith('/') ? path : `/${path}`;
  }
};
